import { useApolloClient } from '@apollo/client';
import { Auth } from '~/amplify';
import type { SignOutInput } from '@aws-amplify/auth';
import { useCallback, useContext } from 'react';
import useIntercom from '../useIntercom';
import { AuthContext } from '~/Root/Auth';
import useErrorReporter from '../useErrorReporter';
import useAddToast from '../useAddToast';
import formatToastMessage from '~/util/formatToastMessage';
import Catalog from '~/Catalog';

type LogoutFn = (opts?: SignOutInput) => Promise<void>;

const useLogout = (): LogoutFn => {
  const client = useApolloClient();
  const intercom = useIntercom();
  const reporter = useErrorReporter();
  const addToast = useAddToast();

  const { ensureLogin } = useContext(AuthContext);

  const logout = useCallback(
    async (opts?: SignOutInput) => {
      try {
        await Auth.signOut(opts);
        await client.clearStore();

        intercom.logOff();
        ensureLogin();
      } catch (error) {
        reporter.captureException(error);
        return addToast([
          formatToastMessage(Catalog.genericUnknownErrorMessage, 'danger'),
        ]);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [client, intercom, ensureLogin],
  );

  return logout;
};

export default useLogout;
